import React from 'react'

const Arrow = () => {
  /* eslint-disable max-len */
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      viewBox="0 0 48 48"
    >
      <path
        d="M22 0C9.85 0 0 9.85 0 22s9.85 22 22 22 22-9.85 22-22C43.987 9.856 34.144.013 22 0zm11.572 23.324L23.467 33.997a1.78 1.78 0 0 1-2.52.081l-.047-.046-.54-.55a1.965 1.965 0 0 1-.078-2.662l4.217-4.717c.67-.752.396-1.368-.612-1.368H11.97a1.834 1.834 0 0 1-1.833-1.833v-1.833c0-1.012.82-1.834 1.833-1.834h11.889c1.008 0 1.283-.608.594-1.35l-4.347-4.727a1.934 1.934 0 0 1 .06-2.646l.55-.55a1.8 1.8 0 0 1 2.547.006l.02.02 10.285 10.68c.7.745.703 1.908.004 2.656z"
      />
    </svg>
  )
  /* eslint-enable */
}

export default Arrow
